import { Status } from '../../Services/Status/Status';
import { LedStatus } from '../../Services/Status/LedStatus';
import { Led } from '../../Components/Led/Led';


export class StatusLed extends Led
{
    private LedStatusToColor: Map<LedStatus, { Color: string; BlinkDuration: number; LightUpDuration: number; }> = new Map([
        [LedStatus.Idle, { Color: "#c8c8c8", BlinkDuration: 0, LightUpDuration: 0 }],
        [LedStatus.CameraConnected, { Color: Led.Green, BlinkDuration: 0, LightUpDuration: 0 }],
        [LedStatus.CameraDisconnected, { Color: Led.White, BlinkDuration: 0, LightUpDuration: 0 }],
        [LedStatus.NewPictureReceived, { Color: "#03ed03", BlinkDuration: 0, LightUpDuration: 300 }],
        [LedStatus.CameraHalted, { Color: "#48a0ff", BlinkDuration: 0, LightUpDuration: 0 }],
        [LedStatus.InputActive, { Color: Led.Yellow, BlinkDuration: 0, LightUpDuration: 500 }],
        [LedStatus.ProblemWithCamera, { Color: Led.Orange, BlinkDuration: 0, LightUpDuration: 0 }],
        [LedStatus.ServerDisconnected, { Color: Led.Red, BlinkDuration: 600, LightUpDuration: 0 }],
        [LedStatus.Unauthorized, { Color: Led.Red, BlinkDuration: 0, LightUpDuration: 0 }],
    ]);

    constructor(private _status: Status)
    {
        super(Led.White);
   
        this._status.LedStatus.OnChange(status =>
        {
            const ledInfo = this.LedStatusToColor.get(status);
        
            this.SetColor(ledInfo?.Color ?? Led.White)
                .Blink(ledInfo?.Color ?? Led.White, ledInfo?.BlinkDuration ?? 0)
                .LightUp(ledInfo?.Color ?? Led.White, ledInfo?.LightUpDuration ?? 0);
        });
    }
}
